/**
 * Точность для биллинговых минут.
 *
 * Единиц измерения здесь нет намеренно — за локализованное «хв / мин / min»
 * отвечает `format-duration.ts`. Здесь только правило, сколько знаков после
 * запятой имеет право потеряться, и оно у котлов и у прозы разное.
 */

/**
 * Минуты в перечислении котлов: 100, а не «100.0», и 0.5, а не «0.5000».
 *
 * Дробные значения реальны — чат расходует долю минуты, — но у целого числа
 * хвост «.0» в перечислении из четырёх величин только шумит.
 *
 * Один знак после запятой при этом печатал непустой котёл нулём:
 * `computeMinuteSplit` округляет каждую долю до сотых, так что частично
 * покрытый чат оставляет, например, 0.04 минуты перерасхода — за них взяли
 * деньги, а карточка показывала «0.0» рядом с пустым котлом «0». Поэтому
 * второй знак появляется ровно там, где первого не хватает.
 */
export function formatMinutes(minutes: number): string {
  if (Number.isInteger(minutes)) return String(minutes);
  const oneDecimal = minutes.toFixed(1);
  return parseFloat(oneDecimal) === 0 ? minutes.toFixed(2) : oneDecimal;
}

/**
 * Минуты внутри предложения: «залишилось 163», а не «залишилось 163.1».
 *
 * Хвост после запятой в прозе — шум, но округление вниз не имеет права
 * превратить положительный остаток в ноль. Находка ревью (Codex, P2): чаты
 * тратят доли минуты, поэтому остаток 0.5 достижим, и `Math.floor` печатал
 * «аналіз іде за рахунок бонусних хвилин, залишилось 0» — предложение,
 * опровергающее само себя в собственной второй половине.
 *
 * Поэтому округление вниз применяется только там, где после него что-то
 * остаётся; ниже минуты величина печатается точно.
 */
export function formatMinutesInProse(minutes: number): string {
  if (minutes >= 1) return String(Math.floor(minutes));
  return formatMinutes(Math.max(0, minutes));
}
